module.exports = __webpack_public_path__ + "img/com.ce60a2fb.jpg";